<template>
  <div class="animated fadeIn sources--sources-list">
    <b-row>
      <b-col v-if="checkClaim(CAN_ADD_POS) && showCreatePO">
        <div class="tools">
          <b-button id="tooltip-target-1" class="fa fa-info" size="sm" variant="info"></b-button>
          <b-tooltip target="tooltip-target-1" triggers="hover">
            <span><b>Select</b> your source to create a PO. Ensure the Sales Order is <b>authorized</b> and a Sales order line has a <b>backorder</b></span>  
          </b-tooltip>     
          <b-button
            size="sm"
            variant="primary"
            @click="$emit('on-create-po')"
            :disabled="isDisabledCreatePO || !selectedRowItemId"
          >Create Purchase Order</b-button>          
        </div>
      </b-col>
      <b-col v-if="!hidePreferBtn">
        <div class="d-flex justify-content-end mb-2">
          <b-button
            size="sm"
            variant="primary"
            :disabled="!selectedRowItemId"
            @click="setPreferredSource"
          >{{ (selectedIsPreferred) ? 'Unprefer' : 'Make Preferred' }}</b-button>
        </div>
      </b-col>
    </b-row>
    <grid-component
        isResizable
        isReorderable
        :gridId="gridId"
        :itemData="itemData"
        :navigationField="'sourceId'"
        :fields="columnFields"
        :onEdit="onEdit"
        :onDelete="onDelete"
        :handleRowClick="handleRowClick"
        @checkedItem="checkedRowItemIdsArr=$event"
      />
    <offer-form
      :modalId="'source-offer-form-modal'"
      :companyModalId="'source-company-modal'"
      :partId="partIdOnForm"
      :lineId="lineIdOnForm"
      :offerId="offerIdOnForm"
      :companyId="companyIdOnForm"
      @onCloseModal="$emit('close-offer-form', $event)"
      @updated-source="loadSources" />
  </div>
</template>

<script>
import debounce from 'lodash/debounce';
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';

import GridSettings from '@/shared/components/GridSettings';
import { sortChange, prepareColumnsData } from '@/shared/helpers';
import { GRID_ID, GRID_PAGE_SIZES, CHECKBOX_GRID_COLUMN } from '@/shared/constants';
import sourcesFields from './fields';
import GridComponent from '@/shared/components/GridComponent';
import OfferForm from '@/shared/components/Offers/components/AddOffer';
//@todo need to implement On order filtering when backend finish this functionality

export default {
  components: {
    GridSettings,
    GridComponent,
    OfferForm
  },
  computed: {
    // ...mapGetters('sources', [
    //   'sourcesList',
    //   'pageInfo',
    // ]),
    ...mapState('requirements', [
      'sourcesList',
    ]),
    ...mapGetters('account', ['gridSettingsById']),
    gridSettings() {
      return this.gridSettingsById(this.gridId);
    },
    anySelectedSources(){
      const selectedSources = this.sourcesList
        .reduce((source, sources) => {
          if (sources.selected) {
            source.push(sources.id);
          }
          return source;
        }, []);

      return selectedSources.length === 0
        ? false
        : true;
    },
    columnFields() {
      let columnFields = [ ...this.fields ];

      if (this.getCheckedIds)
        columnFields.unshift(CHECKBOX_GRID_COLUMN);
      
      return columnFields;
    },
    itemData() {
      let data = (this.showPreferredOnly) ? this.sourcesList.filter(source => source.isPreferred == true) 
        : (this.parentData) ? this.parentData : this.sourcesList;
      console.log(data, "Data used", this.sourcesList, this.parentData)

      return data ? data.map((source) => ({ ...source, selected: source.id === this.selectedRowItemId })) : [];
    },
  },
  props: {
    crfqLineId: [Number, String],
    gridId: [String],
    partId: [Number, String],
    showPreferredOnly: [Boolean],
    quoteId: [Number, String],
    salesOrderId: [Number, String],
    showCreatePO: [Boolean],
    isDisabledCreatePO: [Boolean],
    getCheckedIds: [Boolean],
    hidePreferBtn: [Boolean],
    parentData: [Array] // Data are provided from the parent component
  },
  data() {
    return {
      prepareColumnsData,
      fields: sourcesFields,
      selectedIsPreferred: false,
      selectedRowItemId: 0,
      selectedItemId: 0,
      partIdOnForm: 0,
      offerIdOnForm: 0,
      lineIdOnForm: 0,
      companyIdOnForm: 0,
      sourceSelected: {},
      checkedRowItemIdsArr: []
    };
  },
  watch: {
    crfqLineId: function() {
      if (this.crfqLineId > 0) {
        this.loadSources();
      } else {
        /*this.clearSources();*/
        this.requirementSetItem({ resource:'sourcesList', payload: []});
        this.purchaseOrderSetItem({ resource: 'poByVendorAndBuyer', payload: [] });
      }
    },
    checkedRowItemIdsArr: function() {
      if (this.getCheckedIds) {
        this.$emit('checked-sources', this.checkedRowItemIdsArr);
      }
    }
  },
  methods: {
    ...mapActions('requirements', [
      'getSources',
      'addPreferredSource',
    ]),
    ...mapActions('sources', [
      'getSourcesForCRFQLineId',
      'getOnOrdersForCRFQLineId',
      'setAsPreffered',
      'addToSources',
      'deleteSource',
    ]),
    ...mapActions('account', ['saveGridSettings']),
    ...mapMutations('requirements', {requirementSetItem:'setItem'}),
    ...mapMutations('purchaseorders', {purchaseOrderSetItem: 'setItem' }),
    handleRowClick(row) {
      this.selectedRowItemId = row.dataItem.id;
      this.selectedIsPreferred = row.dataItem.isPreferred;
      this.$emit('selected', row.dataItem);
    },
    async loadSources() {
      if (!this.parentData) {
        let reqId = (this.crfqLineId) ? this.crfqLineId : this.$route.params.crfqLineId;
        if(reqId) {
          await this.getSources(reqId);
          this.$emit('onSourcesLoad');
        } else {
          /*this.clearSources();*/
          this.requirementSetItem({ resource:'sourcesList', payload: []});
        }
      }
    },
    async setPreferredSource() {
      const { id, requirementLineId } = this.itemData.find(item => item.id === this.selectedRowItemId);

      await this.addPreferredSource({ sourceId: id, lineId: requirementLineId }).then(() => {
        this.selectedRowItemId = 0;
      });

      this.$emit('onChangeSource');
    },

    onClear() {
      this.partIdOnForm = 0;
      this.lineIdOnForm = 0;
      this.companyIdOnForm = 0;
      this.offerIdOnForm = 0;
    },
    onEdit: function(item) {
      switch(item.source)
      {
        case "Offers":
          this.partIdOnForm = item.partId;
          this.lineIdOnForm = item.requirementLineId;
          this.companyIdOnForm = item.vendorId;
          this.offerIdOnForm = item.vrfpLineId;
          this.$bvModal.show('source-offer-form-modal');
          break;

        case "Inventory":
          let routeInventory = this.$router.resolve({
            name: 'inventory.partDetails',
            params: { id: item.inventoryId },
          });
          window.open(routeInventory.href, '_blank');
          break;

        case "OnOrder":
          let routePO = this.$router.resolve({
            name: 'purchaseorders.edit',
            params: { id: item.purchaseOrderId },
          });
          window.open(routePO.href, '_blank');
          break;
      }

    },
    async onDelete(source) {
      const deleteConfirmed = await this.openConfirmBox({message: 'Are you sure you want to delete source?'});
      if (deleteConfirmed) {
        await this.deleteSource(source.id).then(() => this.loadSources());
        this.$snotify.success('Source Deleted', 'Requirement Source');
      }
    },
  },
  mounted() {
    this.loadSources();
  },
};
</script>

<style lang="scss">
.sources {
  &--sources-list {
    table td {
      cursor: pointer;
    }
  }
}
.parts-grid {
  height: auto !important;
}
.add-to-sources {
  margin-top: 0.5em;
  margin-bottom: 1em;
}
</style>
